<template>
  <div id="chartColumn" style="width: 100%; height: 340px"></div>
</template>
<script>
import echarts from "echarts";
export default {
  data() {
    return {
      areaDataTmp: {},
      chartColumn: null,
      screenWidth: document.body.clientWidth,
    };
  },
  props: {
    areaData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  mounted() {
    window.onresize = () => {
      this.screenWidth = document.body.clientWidth;
    };
    this.drawLine(this.screenWidth);
  },
  methods: {
    drawLine(wid) {
      this.chartColumn = echarts.init(document.getElementById("chartColumn"));
      this.areaDataTmp = JSON.parse(JSON.stringify(this.areaData));
      for (let i = 0; i < this.areaDataTmp.pre.data.length; i++) {
        if (
          this.areaDataTmp.pre.data[i] &&
          !isNaN(this.areaDataTmp.pre.data[i])
        ) {
          this.areaDataTmp.pre.data[i] = this.areaDataTmp.pre.data[i].toFixed(
            2
          );
        }
      }
      for (let i = 0; i < this.areaDataTmp.curr.data.length; i++) {
        if (
          this.areaDataTmp.curr.data[i] &&
          !isNaN(this.areaDataTmp.curr.data[i])
        ) {
          this.areaDataTmp.curr.data[i] = this.areaDataTmp.curr.data[i].toFixed(
            2
          );
        }
      }
      for (let i = 0; i < this.areaDataTmp.profit.data.length; i++) {
        if (
          this.areaDataTmp.profit.data[i] &&
          !isNaN(this.areaDataTmp.profit.data[i])
        ) {
          this.areaDataTmp.profit.data[i] = this.areaDataTmp.profit.data[
            i
          ].toFixed(1);
        }
      }
      this.chartColumn.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
          formatter:
            "{b0}</br>{a0}:{c0} " + this.areaDataTmp.unit + "</br>{a1}:{c1}% ",
        },
        toolbox: {
          feature: {
            dataView: { show: false, readOnly: false },
            magicType: { show: false, type: ["line", "bar"] },
            restore: { show: false },
            saveAsImage: { show: false },
          },
        },
        legend: {
          data: [this.areaDataTmp.curr.name, this.areaDataTmp.profit.name],
        },
        xAxis: [
          {
            type: "category",
            data: this.areaDataTmp.xAxis,
            axisPointer: {
              type: "shadow",
            },
            axisLabel: { interval: 0, rotate: 0 },
            showMaxLabel: true,
            showMinLabel: true,
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "单位：" + this.areaDataTmp.unit,
            axisLabel: {
              formatter: "{value}",
            },
          },
          {
            type: "value",
            name: "单位：%",
            axisLabel: {
              formatter: "{value}",
            },
          },
        ],
        dataZoom: {
          show: wid > 1200 ? false : true,
          realtime: true,
          type: "slider", // 有type这个属性，滚动条在最下面，也可以不行，写y：36，这表示距离顶端36px，一般就是在图上面。
          height: 10, // 表示滚动条的高度，也就是粗细
          start: 20, // 表示默认展示20%～80%这一段。
          end: 80,
        },
        series: [
          {
            name: this.areaDataTmp.curr.name,
            type: "bar",
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#96f691" },
                { offset: 0.5, color: "#68eef0" },
                { offset: 1, color: "#8cccf0" },
              ]),
            },
            barMaxWidth: 30,
            data: this.areaDataTmp.curr.data,
          },
          {
            name: this.areaDataTmp.profit.name,
            type: "line",
            yAxisIndex: 1,
            data: this.areaDataTmp.profit.data,
          },
        ],
        grid: {
          show: true,
          borderColor: "#19507c",
          x: 30,
          x2: 30,
          y2: 40,
        },
      });
    },
  },
};
</script>
<style lang="less">
.sidebar-container {
  transition: width 0.28s;
  width: 248px !important;
  height: 100%;
  font-size: 0px;
  bottom: 0;
  z-index: 1001;
  overflow: auto;

  .horizontal-collapse-transition {
    transition: 0s width ease-in-out, 0s padding-left ease-in-out,
      0s padding-right ease-in-out;
  }
  .el-scrollbar {
    height: 100%;
  }
  .scrollbar-wrapper {
    overflow-x: hidden !important;
    .el-scrollbar__view {
      height: 100%;
    }
  }
  .el-scrollbar__bar.is-vertical {
    right: 0px;
  }
  .is-horizontal {
    display: none;
  }
  a {
    display: inline-block;
    width: 100%;
    overflow: hidden;
  }
  .el-menu {
    border: none;
    height: 100%;
    width: 100% !important;
  }
  .is-active {
    background-color: #5584ff !important;
  }
  .is-active > .el-submenu__title {
    color: #f4f4f5 !important;
  }
}
</style>